import { gql } from "@apollo/client";

const SPORTS_BY_ID = gql`
  query sport($id: Int!) {
    sport(id: $id) {
      id
      title
      icon
      resourceTitle
      abbreviation
      enableDiscipline
      enableCourts
      enableStages
      displayDraws
      displayGroups
      displayLiveStandings
      displayOrderPlay
      displayListResults
      displayPendingResults
      displayTournamentResults
      isEnablePairingStandings
      isEnableRounds
      textBox
      isDisplaySeeds
      isDisplaySegments
      isDisplayAthleteChessTitle
      footballLineupEnabled
      footballAdvancedMatchDetailsEnabled
      footballGroupStandingsEnabled
      footballLiveStandingsEnabled
    }
  }
`;

export default SPORTS_BY_ID;
